import React from 'react';
import { Icon } from '@iconify/react';

const IconWrap = ({ icon, className, size = '6' }) => {
  return (
    <div className={`size-${size} ${className} inline-block`}>
      <Icon icon={icon} />
    </div>
  );
};

export default IconWrap;
